<template>
  <v-card
    style="height: 100%"
    class=""
  >
    <v-card-title class="text-capitalize">{{ $t("Détails") }}
    <v-spacer />
      <v-btn
        icon
        x-small
        color="primary"
      >
        <v-icon
          color="primary"
          small
          @click="openDialog({})"
        >
          {{ icons.mdiPencil }}
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="text--primary overflow-y-auto" style="max-height: 250px">
      <v-row no-gutters>

        <v-col
          cols="12"
          class="d-flex justify-start"
        >
          <span>{{ $t("Age") }} :</span>
          <div class="text--primary font-weight-semibold ml-2">
            {{ author.age || '-' }} ans
          </div>
        </v-col>
        <v-col
          cols="12"
          class="d-flex"
        >
          <span>{{ $t("Type d’auteur") }} :</span>
          <div class="text--primary font-weight-semibold ml-2">
            {{ author.author_type ? author.author_type.label:'' }}
          </div>
        </v-col>
        <v-col
          cols="12"
          class="d-flex justify-start"
        >
          <span>{{ $t("Informations particulières") }} :</span>
          <div class="text--primary font-weight-semibold ml-2">
            {{ author.author_state ? author.author_state.label:'' }} <span v-if="author.reason_for_anonymity">({{ author.reason_for_anonymity ? author.reason_for_anonymity : '-' }})</span>
          </div>
        </v-col>
        <v-col
          cols="12"
          class="d-flex justify-start"
        >
          <span>{{ $t("Autres informations") }} :</span>
          <div class="text--primary font-weight-semibold ml-2">
            {{ author.others_informations ? author.others_informations:'' }}
          </div>
        </v-col>


      </v-row>
    </v-card-text>
    <v-dialog
      v-model="isFormActive"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 600 : '100%'"
    >
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="onSubmit"
      >
        <v-card
          height="100%"
          flat
        >
          <v-card-title>
            <span class="font-weight-semibold text-base text--primary">{{ $t('Modifier') }}</span>
            <v-spacer />
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              color="error"
              @click="isFormActive = false"
            >
              <v-icon size="22">
                {{ icons.mdiClose }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text
            class="overflow-y-auto"
            style="max-height: 700px;"
          >
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="author.author_type_id"
                  :label="$t('Type d’auteur')"
                  :items="$store.state.app.authorTypes"
                  required
                  item-text="label"
                  item-value="id"
                  outlined
                  dense
                  hide-details="auto"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <date-picker
                  v-model="author.dob"
                  outlined
                  dense
                  :label="$t('Date de naissance')"
                  :placeholder="$t('Date de naissance')"
                  :error-messages="errorMessages.dob"
                  hide-details="auto"
                ></date-picker>
              </v-col>
              <v-col
                cols="12"
              >
                <v-autocomplete
                  v-model="author.author_state_id"
                  :label="$t('Informations particulières')"
                  :items="$store.state.app.authorStates"
                  required
                  item-text="label"
                  item-value="id"
                  outlined
                  dense
                  hide-details="auto"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="author.reason_for_anonymity"
                  outlined
                  dense
                  :label="$t('Raison de l\'information particulière')"
                  :placeholder="$t('Raison de l\'information particulière')"
                  :error-messages="errorMessages.reason_for_anonymity"
                  hide-details="auto"
                ></v-textarea>
              </v-col>
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="author.others_informations"
                  outlined
                  dense
                  :label="$t('Autres informations')"
                  :placeholder="$t('Autres informations')"
                ></v-textarea>
              </v-col>

            </v-row>
          </v-card-text>
          <v-card-actions>
<!--            <v-btn
              :loading="loading"
              color="secondary"
              outlined
              type="reset"
              @click="is"
            >
              {{ $t('Annuler') }}
            </v-btn>-->
            <v-spacer />
            <v-btn
              :loading="loading"
              color="primary"
              class="me-3"
              type="submit"
            >
              {{ $t("Enregistrer") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="isDeleteFormActive"
      touchless
      :right="!$vuetify.rtl"
      width="400"
    >
      <v-card
        height="100%"
        flat
      >
        <v-card-title>
          <span class="font-weight-semibold text-base text--primary">{{ $t("Confirmer la suppression") }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            color="error"
            @click="isDeleteFormActive = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="overflow-y-auto"
          style="max-height: 700px;"
        >
          <p class="text-center">
            {{ $t("Êtes-vous sûr de vouloir supprimer cet élément ?") }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="deleting"
            color="secondary"
            outlined
            type="reset"
            @click="isDeleteFormActive = false"
          >
            {{ $t('Annuler') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :loading="deleting"
            color="primary"
            class="me-3"
            @click="deleteItem"
          >
            {{ $t("Continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="isSnackbarBottomVisible"
      :color="$vuetify.theme.currentTheme.error"
      :light="$vuetify.theme.dark"
    >
      {{ snackBarMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import {
  mdiClose, mdiPencilOutline, mdiPencilOffOutline, mdiDeleteOutline, mdiPlus,mdiPencil
} from '@mdi/js'
import { computed, onUnmounted, ref } from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'
import { avatarText, formatDate } from '@core/utils/filter'
import axios from '@axios'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import DatePicker from "@/components/DatePicker.vue";

/* import useAuthorsList from './useAuthorsList'
import FileUpload from '@/components/file_upload'
import Addresses from '@/views/apps/author/author-list/Addresses'
import authorStoreModule from '@/views/apps/author/authorStoreModule'
import AuthorForm from "@/views/apps/author/author-list/AuthorForm.vue"; */

export default {
  components: {
    DatePicker
  },
  model: {
    prop: 'object',
  },
  props: {
    object: {
      type: Object,
      default: () => {},
    },
  },
  methods: { formatDate },
  setup(props, { emit }) {
    const errorMessages = ref({ })
    const valid = ref(false)
    const loading = ref(false)
    const deleting = ref(false)
    const item = ref({})
    const isFormActive = ref(false)
    const isDeleteFormActive = ref(false)
    const form = ref(null)
    const isSnackbarBottomVisible = ref(false)
    const snackBarMessage = ref('')
    const validate = () => {
      form.value.validate()
    }

    const author = computed({
      get: () => props.object,
      set: value => emit('object', value),
    })
    author.value.author_salons = author.value.author_salons || []

    // const item = ref(JSON.parse(JSON.stringify(blankItem)))
    const resetItem = () => {
      // item.value = {}
      // resetForm()

      isFormActive.value = false
    }
    const deleteItem = () => {
      if (!item.value.id) author.value.author_salons.splice(author.value.author_salons.findIndex(e => e.id === item.value.id), 1)
      deleting.value = true
      axios.delete(`/author/${author.value.id}/salons/${item.value.id}`).then(response => {
        isDeleteFormActive.value = false
        deleting.value = false
        emit('object', response.data)
       // author.value = response.data
       emit('refresh-data')


      }).then(() => {
        isDeleteFormActive.value = false
        deleting.value = false
      })
    }
    const openDialog = it => {
      item.value = it || {}

      isFormActive.value = true
    }
    const openDeleteDialog = it => {
      item.value = it || {}
      deleting.value = false
      isDeleteFormActive.value = true
    }

    const onSubmit = () => {
     /* if (!item.value.type) {
        isSnackbarBottomVisible.value = true
        snackBarMessage.value = 'Veuillez saisir un nom d\'événement.'

        return
      }*/
      if (valid.value) {
        loading.value = true
        console.log('saving info', item.value)
        axios.post(`author/${author.value.id}/info`, author.value)
          .then(response => {
            loading.value = false
            isFormActive.value = false
            if (response.data.error || response.data.errors || (response.data.status && response.data.status === 'false')) {
              if (response.data.errors) {
                // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
                errorMessages.value = { ...response.data.errors }
              } else {
                isSnackbarBottomVisible.value = true
                snackBarMessage.value = response.data.message

                // this.toast(response.data.message, this.$vuetify.theme.currentTheme.error)
              }

              return false
            }

            // resetItem()
            emit('object', response.data)
            //author.value = response.data
            emit('refresh-data')

            // emit('update:is-form-active', false)
          }).catch(() => {
            loading.value = false
            isFormActive.value = false
          }).catch(error => {
            loading.value = false
            isFormActive.value = false
            console.log('error', error)
            if (error.data.errors) {
            // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
              errorMessages.value = { ...error.data.errors }
            }
          })
      } else {
        validate()
      }
    }

    // eslint-disable-next-line no-unused-vars
    /* watch(() => props.object, (newValue, prevValue) => {
      if (!newValue || !newValue.id) {
        resetItem()
      } else {
        item.value = JSON.parse(JSON.stringify(newValue))
      }
    }) */
    // eslint-disable-next-line no-unused-vars
    /* watch(() => item, (newValue, prevValue) => {
      console.log('item change', newValue.value)
      emit('input', newValue.value)
    }, { deep: true }) */

    /* store
      .dispatch('app/fetchNetworks', { per_page: 500 }) */

    return {
      openDialog,
      openDeleteDialog,
      resetItem,
      deleteItem,
      form,
      loading,
      deleting,
      isFormActive,
      isDeleteFormActive,
      isSnackbarBottomVisible,
      snackBarMessage,
      errorMessages,
      onSubmit,
      countries,
      item,
      author,
      valid,
      validate,
      avatarText,

      // validation
      validators: { required, emailValidator },
      icons: {
        mdiClose,
        mdiPencilOffOutline,
        mdiPencilOutline,
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil
      },
    }
  },
}
</script>
